import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Button } from './ui/button';
import { trackButtonClick } from '../lib/analytics';

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  const scrollToSection = (sectionId) => {
    trackButtonClick(sectionId === 'about' ? '關於明悅' : '業務核心', 'header_nav');
    if (!isHomePage) {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  const handleLogoClick = () => {
    trackButtonClick('Logo', 'header_nav');
    navigate('/');
  };

  const handleFounderClick = () => {
    trackButtonClick('創辦人', 'header_nav');
    navigate('/founder');
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm shadow-sm">
      <div className="container mx-auto px-4 sm:px-6 py-3 sm:py-4">
        <div className="flex flex-col md:flex-row items-center md:justify-between gap-3 md:gap-0">
          {/* Logo */}
          <div
            className="flex items-center justify-center gap-4 cursor-pointer logo-area"
            onClick={handleLogoClick}
          >
            <img
              src="https://customer-assets.emergentagent.com/job_cultural-gateway-2/artifacts/8dutq6z7_LOGONEW.png"
              alt="明悅心創 Ming Yue Culture"
              className="h-12 sm:h-16 w-auto object-contain"
            />
          </div>

          {/* Navigation Buttons */}
          <div className="flex items-center justify-center flex-wrap gap-2 sm:gap-4">
            <Button
              variant="outline"
              className="rounded-full px-4 sm:px-6 py-2 text-sm sm:text-base border-2 border-orange-400 text-orange-600 hover:bg-orange-50 transition-all duration-300"
              onClick={() => scrollToSection('about')}
            >
              關於明悅
            </Button>
            <Button
              variant="outline"
              className="rounded-full px-4 sm:px-6 py-2 text-sm sm:text-base border-2 border-orange-400 text-orange-600 hover:bg-orange-50 transition-all duration-300"
              onClick={handleFounderClick}
            >
              創辦人
            </Button>
            <Button
              variant="outline"
              className="rounded-full px-4 sm:px-6 py-2 text-sm sm:text-base border-2 border-orange-400 text-orange-600 hover:bg-orange-50 transition-all duration-300"
              onClick={() => scrollToSection('services')}
            >
              業務核心
            </Button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;